import { liveItems } from "@/mocks/news";

const badgeStyle: Record<string, string> = {
  "现场": "bg-secondary-500 text-background-50",
  "直击": "bg-primary-500 text-background-50",
  "围观": "bg-accent-400 text-foreground-950",
};

export default function LiveSection() {
  return (
    <section id="live" className="scroll-mt-32 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="mb-8 flex flex-col sm:flex-row sm:items-end justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium text-secondary-700">
              <i className="ri-live-line text-base" aria-hidden="true"></i>
              ON SCENE
            </span>
            <h2 className="font-heading mt-2 text-2xl md:text-3xl font-bold text-foreground-950">
              现场直击
            </h2>
            <p className="mt-2 text-sm text-foreground-500">从活动现场到街头巷尾，第一时间带你看现场</p>
          </div>
          <a
            href="#digest"
            className="inline-flex whitespace-nowrap items-center gap-1.5 self-start text-sm font-medium text-secondary-700 hover:text-secondary-900"
          >
            查看速报 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {liveItems.map((item) => (
            <a
              key={item.time}
              href="#columns"
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title}现场实况图`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className={`absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-medium ${badgeStyle[item.badge]}`}>
                  <i className="ri-live-fill text-[10px]" aria-hidden="true"></i>
                  {item.badge}
                </span>
                <span className="absolute right-3 top-3 whitespace-nowrap rounded-md bg-foreground-950/60 px-2 py-0.5 text-[11px] text-background-100 backdrop-blur-sm">
                  {item.time}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <span className="mb-2 inline-flex w-fit whitespace-nowrap rounded-md bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500">
                  {item.category}
                </span>
                <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <div className="mt-auto pt-4 flex items-center gap-4 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {item.reads}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-account-circle-line" aria-hidden="true"></i>
                    现场记者
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}